import { CALL_API } from "constants/api";
import {
    ACTIVE_LIST_ADD,
    ACTIVE_LIST_CLEAR,
    ACTIVE_LIST_ENTRIES_FAILURE,
    ACTIVE_LIST_ENTRIES_REQUEST,
    ACTIVE_LIST_ENTRIES_SUCCESS,
    ACTIVE_LIST_REMOVE,
    ACTIVE_LIST_REMOVE_FAILURE,
    ACTIVE_LIST_REMOVE_SUCCESS,
    ACTIVE_LIST_REMOVE_REQUEST,
    ACTIVE_LIST_SET,
} from "constants/action-types";

export const activeListFetchEntries = (catalog) => {
    return (dispatch, getState) => {
        const { activeList, scope } = getState();
        catalog = catalog || activeList.current;
        const query = {
            __fields: "item_id",
            __limit: 500,
            __archived: false,
            __view_disabled: true,
            __type: "item",
        };

        if (scope.viewAs) {
            query.__company = scope.viewAs._id;
        }

        dispatch({
            [CALL_API]: {
                types: [ACTIVE_LIST_ENTRIES_REQUEST, ACTIVE_LIST_ENTRIES_SUCCESS, ACTIVE_LIST_ENTRIES_FAILURE],
                endpoint: `/api/v3.1/catalog/${catalog.id}/entries`,
                fetchAll: true,
                maxPages: 8,
                query,
            },
        });
    };
};

export const activeListSet = (catalog, { fetch = true } = {}) => {
    return (dispatch) => {
        if (catalog.type === "custom-list") {
            if (fetch) {
                dispatch(activeListFetchEntries(catalog));
            }

            dispatch({
                type: ACTIVE_LIST_SET,
                payload: catalog,
            });
        }
    };
};

export const activeListAdd = (itemIds) => {
    return {
        type: ACTIVE_LIST_ADD,
        payload: Array.isArray(itemIds) ? itemIds : [itemIds],
    };
};

export const activeListRemove = (itemIds) => {
    return {
        type: ACTIVE_LIST_REMOVE,
        payload: Array.isArray(itemIds) ? itemIds : [itemIds],
    };
};

export const activeListRemoveAndDelete = (itemIds) => {
    return (dispatch, getState) => {
        const catalog = getState().activeList.current;
        const ids = Array.isArray(itemIds) ? itemIds : [itemIds];
        if (catalog) {
            dispatch({
                [CALL_API]: {
                    types: [ACTIVE_LIST_REMOVE_REQUEST, ACTIVE_LIST_REMOVE_SUCCESS, ACTIVE_LIST_REMOVE_FAILURE],
                    endpoint: `/api/v3.0/catalog/${catalog.id}/entries`,
                    method: "DELETE",
                    query: { item_id: ids.join(",") },
                    meta: {
                        itemIds: ids,
                    },
                },
            });
        }
    };
};

export const activeListClear = () => {
    return {
        type: ACTIVE_LIST_CLEAR,
    };
};
